const styles = {
    rightIcon: {
        position: 'absolute',
        right: 0,
    },
};

export default styles;



// WEBPACK FOOTER //
// src/components/achievement/UserAchievementList/UserAchievementList.css.js